import { render, staticRenderFns } from "./gongwenadd.vue?vue&type=template&id=24b42d22&scoped=true"
import script from "./gongwenadd.vue?vue&type=script&lang=js"
export * from "./gongwenadd.vue?vue&type=script&lang=js"
import style0 from "./gongwenadd.vue?vue&type=style&index=0&id=24b42d22&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b42d22",
  null
  
)

export default component.exports